import { m, useReducedMotion } from "framer-motion";
import { transition, viewport } from "./presets";

export default function ScrollReveal({
    children,
    className,
    delay = 0,
    y = 24,
    as: Tag = m.div,
}) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <Tag
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
            variants={{
                hidden: { opacity: 0, y },
                visible: { opacity: 1, y: 0 },
            }}
            transition={{ ...transition, delay }}
        >
            {children}
        </Tag>
    );
}
